<style lang="scss" scoped>
.invalid-feedback {
  display: block;
}
</style>

<template>
  <div>
    <div class="btn-group">
      <button
        v-for="(type, typeKey) in types"
        :key="typeKey"
        type="button"
        class="btn"
        @click="addMessage(typeKey)"
      >
        +{{ type }}
      </button>
    </div>
    <div
      class="d-flex"
      v-for="(element, index) in elements"
      :key="element.type + '-' + index"
    >
      <sorter
        v-if="element.type !== 'pause' && elements.length > 1"
        class="mr-2"
        :index="index"
        :last="index === elements.length - 1"
        :first="index === 0"
        @sort="sort"
      >
      </sorter>
      <component
        class="w-100 mr-2 d-flex flex-column justify-content-center"
        :is="messageElement(element.type)"
        v-model="element.value"
        @input="emitValue"
        :attributeErrors="element.errors"
        :index="index"
      >
      </component>
      <button
        v-if="element.type !== 'pause'"
        type="button"
        class="btn btn-danger align-self-start mt-0"
        @click="removeElement(index)"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div
      v-for="error in attribute.errors"
      :key="error"
      class="invalid-feedback"
    >
      {{ error }}
    </div>
  </div>
</template>

<script lang="babel">
import TextMessageElement from '@/components/selector/MessageElements/TextMessageElement';
import PauseMessageElement from '@/components/selector/MessageElements/PauseMessageElement';
import GifMessageElement from '@/components/selector/MessageElements/GifMessageElement';
import GiftMessageElement from '@/components/selector/MessageElements/GiftMessageElement';
import ImageMessageElement from '@/components/selector/MessageElements/ImageMessageElement';
import SmileMessageElement from '@/components/selector/MessageElements/SmileMessageElement';
import FriendrequestMessageElement from '@/components/selector/MessageElements/FriendrequestMessageElement';
import Sorter from '@/components/selector/MessageElements/Sorter';

export default {
  components: {
    TextMessageElement,
    PauseMessageElement,
    GifMessageElement,
    GiftMessageElement,
    ImageMessageElement,
    SmileMessageElement,
    FriendrequestMessageElement,
    Sorter
  },
  props: {
    value: {
      required: true,
    },
    attribute: {
      required: true,
      type: Object,
    }
  },
  data() {
    return {
      elements: [],
      types: {
        text: 'Text',
        gif: 'GIF',
        image: 'Bild',
        gift: 'Geschenk',
        smile: Laravel.settings.blinkName,
        friendrequest: 'Freundschaftsanfrage'
      }
    };
  },
  mounted() {
    this.setupNestedErrors();
    this.setupElements();
  },
  computed: {
    hasErrors() {
      return this.attribute.errors.length !== 0;
    },
    rows() {
      return this.attribute.rows === undefined ? 3 : this.attribute.rows;
    },
    disabled() {
      return Boolean(this.attribute.disabled);
    },
    nestedErrors() {
      return this.attribute.nestedErrors;
    }
  },
  methods: {
    setupElements() {
      if (!this.value) {
        return;
      }

      this.value.forEach(message => {
        let value;

        if (message.type === 'pause') {
          value = JSON.parse(message.value);
        } else if (message.type === 'image') {
          value = message.id;
        } else {
          value = message.value;
        }

        this.elements.push({
          type: message.type,
          value: value,
          errors: []
        });
      });
    },
    addMessage(type) {
      if (this.elements.length > 0) {
        this.elements.push({
          type: 'pause',
          value: [0, 0],
          errors: []
        });
      }

      this.elements.push({
        type: type,
        value: type == 'smile' || type == 'friendrequest' ? 0 : null,
        errors: []
      });
    },
    messageElement(type) {
      switch(type) {
        case 'text':
          return 'TextMessageElement';
        case 'pause':
          return 'PauseMessageElement';
        case 'gif':
          return 'GifMessageElement';
        case 'gift':
          return 'GiftMessageElement';
        case 'image':
          return 'ImageMessageElement';
        case 'smile':
          return 'SmileMessageElement';
        case 'friendrequest':
          return 'FriendrequestMessageElement';
      }
    },
    sort({ direction, index }) {
      let otherIndex;
      if (direction === 'up') {
        otherIndex = index - 2;
      } else {
        otherIndex = index + 2;
      }

      let otherElement = this.elements[otherIndex];
      this.$set(this.elements, otherIndex, this.elements[index]);
      this.$set(this.elements, index, otherElement);
    },
    removeElement(index) {
      let fromIndex = index;
      if (index === this.elements.length - 1) {
        fromIndex = index - 1;
      }
      this.elements.splice(fromIndex, 2);
    },
    emitValue() {
      this.$emit("input", this.elements);
    },
    setupNestedErrors() {
      this.elements.forEach(element => {
        element.errors = [];
      });

      Object.keys(this.nestedErrors).forEach(errorKey => {
        let nestedKeys = errorKey.split(".");
        let index = nestedKeys[0];
        let errorArray = [];
        this.nestedErrors[errorKey].forEach(error => {
          if (Array.isArray(error)) {
            errorArray.push(error);
          } else {
            errorArray.push([error]);
          }
        });
        this.$set(this.elements[index], 'errors', this.elements[index].errors.concat(errorArray));
      });
    }
  },
  watch: {
    elements: {
      handler: function() {
        this.emitValue();
      },
      deep: true
    },
    nestedErrors() {
      this.setupNestedErrors();
    }
  }
}
</script>
